import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiWarningSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4ZM4.5 3.158A7.035 7.035 0 0 0 1 5.065l.71.7a6.03 6.03 0 0 1 2.79-1.59V3.159ZM4.5 5.727c-.66.229-1.248.605-1.727 1.088l.71.7a3.52 3.52 0 0 1 1.044-.731A1.508 1.508 0 0 1 4.5 6.5v-.773ZM7.473 6.784c.018-.092.027-.187.027-.284v-.773c.66.229 1.248.605 1.727 1.088l-.71.7a3.52 3.52 0 0 0-1.044-.731ZM10.29 5.765A6.03 6.03 0 0 0 7.5 4.176V3.159A7.035 7.035 0 0 1 11 5.065l-.71.7ZM6 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" />
  </svg>
);
export default IconWifiWarningSizeXs;
